import Vue from 'vue'
import {TasksResource, getWithPagination} from '../../util/api'

const initialState = {
  objects: {},
  objectsActive: {},
  createdObject: null, // The most recent Object to be created
  updatedObject: null, // The most recent Object to be updatd
  getInProgress: false, // Is a GET request in progress for this Store?
  createInProgress: false, // Is a GET request in progress for this Store?
  updateInProgress: false, // Is a POST or PUT request in progress for this Store?
  deleteInProgress: false // Is a DELETE request in progress for this Store?
}

export default {
  state: { ...initialState },
  mutations: {
    SET_TASKS (state, objects) {
      let updatedObjects = {}
      for (let key in objects) {
        if (objects.hasOwnProperty(key)) {
          if (objects[key].deleted_at === null) {
            // Stage the update so we can just do one Vue.set
            updatedObjects[objects[key].id] = objects[key]
          } else if (state.objects.hasOwnProperty(objects[key].id)) {
            // Immediately delete the object
            Vue.delete(state.objects, objects[key].id)
          }
        }
      }
      state.objects = {
        ...state.objects,
        ...updatedObjects
      }
    },
    SET_TASKS_ACTIVE(state, objects) {
      // console.log('objects',objects)
      let updatedObjects = {}
      // state.objectsActive = {}
      for (let key in objects) {
        if (objects.hasOwnProperty(key)) {
          if(objects[key].is_log_active){
            // console.log('objectsActive ====== ',objects[key])
            if (objects[key].deleted_at === null) {
              // Stage the update so we can just do one Vue.set
              updatedObjects[objects[key].id] = objects[key]
            } else if (state.objectsActive.hasOwnProperty(objects[key].id)) {
              // Immediately delete the object
              Vue.delete(state.objectsActive, objects[key].id)
            }
          }
        }
      }
      state.objectsActive = {
        ...state.objectsActive,
        ...updatedObjects
      }
    },
    SET_TASK (state, object) {
      if (object.deleted_at === null) {
        Vue.set(state.objects, object.id, object)
      } else {
        Vue.delete(state.objects, object.id)
      }
    },
    CREATED_TASK (state, object) {
      state.createdObject = object
    },
    UPDATED_TASK (state, object) {
      state.updatedObject = object
    },

    // Progress States
    GET_TASK_IN_PROGRESS (state, value) {
      state.getInProgress = value
    },
    CREATE_TASK_IN_PROGRESS (state, value) {
      state.createInProgress = value
    },
    UPDATE_TASK_IN_PROGRESS (state, value) {
      state.updateInProgress = value
    },
    DELETE_TASK_IN_PROGRESS (state, value) {
      state.deleteInProgress = value
    },

    TASKS_CLEAR_ALL (state) {
      for (let key in initialState) {
        Vue.set(state, key, initialState[key])
      }
    }
  },

  actions: {
    getTask ({ commit }, id) {
      try {
        TasksResource.get({id: id}).then((response) => {
          commit('SET_TASK', response.body)
        }, () => {
          // @TODO: Implement error handling
        })
      } catch (ex) {
        // Request was most likely cancelled due to existing in flight request
      }
    },

    getTasks ({ commit }, params) {
      // Download all tasks
      getWithPagination(TasksResource, params, response => {
        // console.log('RESULT!!!!!')
        // console.log('response',response.body.data)
        // Note: Pagination requests return the objects under the 'data' key
        // console.log('response.body.data',response.body.data)
        commit('SET_TASKS', response.body.data)
      }, () => {
        // Completion handler
      }, () => {
        // Error handler
      })
    },

    getTasksActive ({ commit }, params) {
      // Download all tasks
      // console.log('getTasks HERE = ',params)
      getWithPagination(TasksResource, params, response => {
        // console.log('RESULT!!!!!')
        // console.log('response',response.body.data)
        // Note: Pagination requests return the objects under the 'data' key
        commit('SET_TASKS_ACTIVE', response.body.data)
      }, () => {
        // Completion handler
        // console.log('Completion handler!!!!!')
      }, () => {
        // Error handler
        // console.log('Error handler!!!!!')
      })
    },

    createTask ({ commit }, object) {
      // Create (POST) a TASK
      commit('CREATED_TASK', null)
      commit('CREATE_TASK_IN_PROGRESS', true)
      TasksResource.save({}, object).then((response) => {
        commit('CREATE_TASK_IN_PROGRESS', false)
        commit('CREATED_TASK', response.body)
        commit('SET_TASK', response.body)
      }, () => {
        console.error('Create TASK Failed')
        commit('CREATE_TASK_IN_PROGRESS', false)
        commit('CREATED_TASK', null)
      })
    },

    updateTask ({ commit }, object) {
      // Update (PUT) a TASK
      commit('UPDATED_TASK', null)
      commit('UPDATE_TASK_IN_PROGRESS', true)
      TasksResource.update({id: object.id}, object).then((response) => {
        commit('UPDATE_TASK_IN_PROGRESS', false)
        commit('UPDATED_TASK', response.body)
        commit('SET_TASK', response.body)
      }, () => {
        commit('UPDATE_TASK_IN_PROGRESS', false)
        commit('UPDATED_TASK', null)
      })
    },

    clearAll ({ commit }) {
      commit('TASKS_CLEAR_ALL')
    }
  }
}
